var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetModemGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 72,
    viewBox: "0 0 324 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 25.5001L100 25.5C101.591 25.5 103.117 26.1321 104.243 27.2574C105.368 28.3826 106 29.9087 106 31.5V40.5C106 42.0913 105.368 43.6174 104.243 44.7426C103.117 45.8679 101.591 46.5 100 46.5H58C56.4087 46.5 54.8826 45.8679 53.7574 44.7426C52.6321 43.6174 52 42.0913 52 40.5V31.5C52 29.9087 52.6321 28.3826 53.7574 27.2574C54.8826 26.1321 56.4087 25.5001 58 25.5001ZM58 40.5V31.5H79H100V40.5H58Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35.6016V35.5711M79 35.6016V35.5711M88 35.6016V35.5711",
    stroke: "#B1B1B1",
    strokeWidth: 6.09624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138 36V36.03M150.198 36V36.03M162.396 36V36.03M174.595 36V36.03M186.793 36V36.03",
    stroke: "#9E9E9E",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254 37.2482V44.2917C252.159 45.9398 251 48.3346 251 51C251 55.9706 255.029 60 260 60C264.971 60 269 55.9706 269 51C269 48.3346 267.841 45.9398 266 44.2918V37.2482C271.298 39.5629 275 44.8491 275 50.9999C275 59.2843 268.284 66 260 66C251.716 66 245 59.2843 245 51C245 44.8491 248.702 39.5629 254 37.2482ZM239 9V30H233L233 18.7643C227.559 22.5592 224 28.864 224 36C224 46.9204 232.335 55.8939 242.991 56.9049C243.773 59.1591 244.991 61.2096 246.544 62.9565C246.033 62.9855 245.518 63 245 63C230.088 63 218 50.9117 218 36C218 27.5181 221.911 19.9496 228.028 14.9998L218 15V9H239ZM263 33V51H257V33H263ZM248.349 9.20573C261.681 10.8553 272 22.2224 272 36C272 36.5184 271.985 37.0331 271.956 37.5441C270.21 35.9913 268.159 34.7733 265.905 33.991C264.976 24.1962 257.318 16.3617 247.605 15.1599L248.349 9.20573Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetModemGray);
export default __webpack_public_path__ + "static/media/reset_modem_gray.4556f914ef873726cfd16a97d1855c1a.svg";
export { ForwardRef as ReactComponent };